// src/pages/ActivarCuenta.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import apiClient from '../services/api';
import Card from '../components/Card';

function ActivarCuenta() {
  const { uid, token } = useParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const navigate = useNavigate();

  useEffect(() => {
    const activar = async () => {
      try {
        await apiClient.post('/activar/', { uid, token });
        setStatus('success');
        setTimeout(() => navigate('/login'), 3000); // Redirigir tras 3s
      } catch (err) {
        setStatus('error');
      }
    };
    activar();
  }, [uid, token, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-fondo p-4">
      <Card className="text-center w-full max-w-md">
        {status === 'loading' && <h2 className="text-xl">Activando tu cuenta... ⏳</h2>}
        
        {status === 'success' && (
          <div>
            <h2 className="text-2xl font-bold text-green-500 mb-2">¡Cuenta Activada! 🎉</h2>
            <p>Redirigiendo al inicio de sesión...</p>
          </div>
        )}

        {status === 'error' && (
          <div>
            <h2 className="text-2xl font-bold text-red-500 mb-2">Error de Activación ❌</h2>
            <p>El enlace es inválido o ya ha sido usado.</p>
            <Link to="/login" className="text-principal hover:underline mt-4 block">Volver</Link>
          </div>
        )}
      </Card>
    </div>
  );
}

export default ActivarCuenta;